$(document).ready(function () {
  initYiiGrid("freelancers-grid", {
    ajaxUpdate: ["freelancers-grid"],
    ajaxVar: "ajax",
    ajaxType: "POST",
    enableHistory: false,
    filterClass: "filters",
    filterSelector: "{filter}",
    loadingClass: "grid-view-loading",
    pageVar: "ProjectsTasks_page",
    pagerClass: "pager",
    selectableRows: 1,
    tableClass: "table table-bordered sr-freelancers-list",
    updateSelector: "{page}, {sort}",
    csrfTokenName: csrfTokenName,
    csrfToken: token,
    afterAjaxUpdate: function () {
      $(".datepicker").each(function () {
        var elem = $(this);
        elem.datepicker({
          format: "dd.mm.yyyy",
          autoclose: true,
          language: "ru",
        });
      });
    },
  });

  $(".exclude-freelancer").click(function (event) {
    event.preventDefault();

    var that = $(this);

    $.SmartMessageBox(
      {
        title: translate.customer_stop_work_caption,
        content: translate.customer_stop_work_message,
        buttons: "[" + translate.button_no + "][" + translate.button_yes + "]",
      },
      function (ButtonPressed) {
        if (ButtonPressed === translate.button_yes) {
          location.href = that.attr("href");
        }
      }
    );
  });
  const rmAddClassExp = (cl, rm, add) => $(cl).removeClass(rm).addClass(add);

  if (Cookies.get("freelancer-info-closed")) {
    toggleFreelPanel();
  }

  $(".toggle-freelancer").on("click", function () {
    if (Cookies.get("freelancer-info-closed")) {
      Cookies.remove("freelancer-info-closed");
    } else {
      Cookies.set("freelancer-info-closed", 1);
    }
    toggleFreelPanel();
  });

  function toggleFreelPanel() {
    $("#freelancer_instructions").toggleClass("closed");

    if ($("#freelancer_instructions").hasClass("closed")) {
      rmAddClassExp(
        "#freelancer_instructions .fa-chevron-up",
        "fa-chevron-up",
        "fa-chevron-down"
      );
      return;
    }

    rmAddClassExp(
      "#freelancer_instructions .fa-chevron-down",
      "fa-chevron-down",
      "fa-chevron-up"
    );
  }

  $("#inviteModal").on("shown.bs.modal", function () {
    $("#invite_email").focus();
  });

  $("#phoneRequestModal").on("shown.bs.modal", function () {
    $("#phone-request").focus();
    $("#phone-request").inputmask({
      mask: "+9999 99[9] [9999] [9][9][9][9][9][9]",
      greedy: false,
    });
  });

  $("#export-freel-xls").on("click", function (e) {
    e.preventDefault();

    let inputs = $(".filters input, .filters select");
    let form = $("#exportFreelancers");
    form.find(".export-freelancer-filter").remove();

    $.each(inputs, function (index, value) {
      let el = $(value)
        .clone()
        .css("display", "none")
        .addClass("export-freelancer-filter");
      form.append(el);
    });

    form.submit();
  });

  $("#export-halva-xls").on("click", function (e) {
    e.preventDefault();

    let inputs = $(".filters input, .filters select");
    let form = $("#exportFreelancers");
    form.find(".export-freelancer-filter").remove();

    $.each(inputs, function (index, value) {
      let el = $(value)
        .clone()
        .css("display", "none")
        .addClass("export-freelancer-filter");
      form.append(el);
    });

    form.append(
      `<input type="hidden" class="export-freelancer-filter" name="isHalvaCardHoldersNeeded" value="true">`
    );
    form.submit();
  });

  $(".customer-note-for-freelancer").editable({
    params: function (params) {
      params["YII_CSRF_TOKEN"] = token;
      return params;
    },
    success: function(response, newValue) {
      response = JSON.parse(response);
      if(response.code !== 0) {
        return response.response;
      }
      return;
    },
  });

  $('.customer-for-freelancer').on('click', function(e) {
    e.preventDefault();

    const $selectCustomerModal = $('#customerModal').modal();
    $selectCustomerModal.css('display', 'block');

    $(".customer-checkbox").on('click', function () {

      let checked = $(this).is(':checked');
      let managerId = $(this).val();
      let freelancerId = $('#freelancer').val();

      if (checked) {
        grantManagerAccessWorker(managerId, freelancerId);
      } else {
        revokeManagerAccessWorker(managerId, freelancerId);
      }

    });

    $('.selectCustomerSave').on('click', function (e) {
      e.preventDefault();
      let freelancerId = $('#freelancer').val();
      location.href = "/freelancers/" + freelancerId;
    });

  });

  let $select = $('#select-managers').select2({
    placeholder: translate.users,
    closeOnSelect: false,
    templateResult: formatState,
    allowHtml: true,
    width: '100%',
  });

  if ($select.data('select2')) {
    $select.data('select2').$dropdown.addClass('select-managers-dropdown');
    $select.data('select2').$container.find('.select2-search--inline input').prop('readonly', true);
    $select.on('change', function() {
      const selectedValues = $(this).val();
      const searchInline = $select.data('select2').$container.find('.select2-search--inline');

      if (selectedValues && selectedValues.length > 0) {
        searchInline.css('width', '0px');
      } else {
        searchInline.css('width', '100%');
      }
    });
  }

  function formatState(state) {
    if (!state.id) {
      return state.text;
    }

    const $state = $(
        '<div id="manager-'+state.id+'" class="flex items-center"><input type="checkbox" class="select2-checkbox my-0 ml-0 mr-10" /> ' + '<span>' + state.text + '</span>' + '</div>'
    );

    $state.find('.select2-checkbox').prop('checked', state.selected);

    $state.on('click', function () {
      $(this).find('.select2-checkbox').prop('checked', state.selected);
      $('#multiSelect').trigger('change');
    });

    return $state;
  }

  $('#setup-managers').on('click', function () {

    let freelancerIds = getFreelancerIds();
    let managerIds = [];

    freelancerIds.forEach((freelancerId) => {
      $('.worker-manager-' + freelancerId).each(function () {
        let managerId = $(this).attr('data-manager-id');
        managerIds.push(managerId);
      });
    });

    managerIds = [...new Set(managerIds)];

    managerIds.forEach((managerId) => {
      $('#customer-manager-' + managerId).prop('checked', true);
    });
  });

  $('.manager-checkbox').on('click', function () {
      let checked = $(this).is(':checked');
      let managerId = $(this).val();
      let freelancerIds = getFreelancerIds();

      freelancerIds.forEach((freelancerId) => {
        if (checked) {
          grantManagerAccessWorker(managerId, freelancerId);
        } else {
          revokeManagerAccessWorker(managerId, freelancerId);
        }
      });
  });

  function getFreelancerIds() {
    let parent = $('.sr-freelancers-list');
    let workers = [];
    $.each(parent.find('input[class="item-check"]:checked'), function () {
      workers.push($(this).data('worker'));
    });
    return workers;
  }

  function grantManagerAccessWorker(managerId, freelancerId) {
    $.ajax({
      url: '/ajax/grantManagerAccessWork',
      type: 'POST',
      data: {YII_CSRF_TOKEN: token, managerIds: [managerId], freelancerId: freelancerId}
    }).done(function (response) {});
  }

  function revokeManagerAccessWorker(managerId, freelancerId) {
    $.ajax({
      url: '/ajax/revokeManagerAccessWork',
      type: 'POST',
      data: {YII_CSRF_TOKEN: token, managerIds: [managerId], freelancerId: freelancerId}
    }).done(function (response) {});
  }

  new ClipboardJS(".copy-to-clipboard", {
    target: function (trigger) {
      return $(`#${$(trigger).attr("data-clipboard-target")}`)[0];
    },
  });
});
